<template>
	<div class="about">
		<template v-if="headerShow">
			<div class="aboutBox">
				<indexTitle :title="$t('新兴技术')" @goMore="goMore"></indexTitle>
				<div class="aboutBox_two">
					<indexAboutSwiper :list='list'></indexAboutSwiper>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="aboutBox aboutBoxH5">
				<indexTitle :title="$t('高效平台')" @goMore="goMore"></indexTitle>
				<div class="aboutBox_two">
					<indexAboutSwiper :list='list'></indexAboutSwiper>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import indexTitle from "./indexTitle.vue"
	import indexAboutSwiper from "./indexAboutSwiper.vue"
	export default {
		components: {
			indexTitle,
			indexAboutSwiper
		},
		data() {
			return {
				list: {
					// list:[
					// 	{
					// 		img:require("@/assets/content/banner.png"),
					// 		name:'澳华内镜',
					// 		cen:"让内镜诊疗变得普及和便携"
					// 	},
					// 	{
					// 		img:require("@/assets/content/banner.png"),
					// 		name:'澳华内镜',
					// 		cen:"让内镜诊疗变得普及和便携"
					// 	},
					// 	{
					// 		img:require("@/assets/content/banner.png"),
					// 		name:'澳华内镜',
					// 		cen:"让内镜诊疗变得普及和便携"
					// 	},
					// ]
				}
			}
		},
		mounted() {

		},
		methods: {
			goMore() {
				console.log("去更多")
				this.$router.push('/about')
			},
			setList(e) {
				console.log(e)
				this.list = e
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.about {
		width: 100%;

		// min-height: 100vh;
		.aboutBox {
			margin: 0 auto;
			width: 1200px;
			padding: 160px 0;
			box-sizing: border-box;

		}

		.aboutBox_two {
			width: 1200px;
			overflow: hidden;


		}
	}

	@media screen and (max-width:1200px) {
		.aboutBoxH5 {
			max-width: 100% !important;
			width:100% !important;
			padding: 30px 0 !important;
			.aboutBox_two {
				max-width: 100% !important;
				width: 100% !important;
			}
		}

	}
</style>